/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Fail_Not_FoundInputs */

const en_import_fail_not_found = /** @type {(inputs: Import_Fail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The video couldn't be found`)
};

const de_import_fail_not_found = /** @type {(inputs: Import_Fail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Video wurde nicht gefunden`)
};

/**
* | output |
* | --- |
* | "The video couldn't be found" |
*
* @param {Import_Fail_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_fail_not_found = /** @type {((inputs?: Import_Fail_Not_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Fail_Not_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_fail_not_found(inputs)
	return en_import_fail_not_found(inputs)
});